import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
const WIDTH = {
    narrow: 'max-w-[960px]',
    default: 'max-w-[1200px]',
    wide: 'max-w-[1600px]',
    full: '',
};
/**
 * Плотность. comfortable ПОБАЙТОВО совпадает с прежним каркасом экрана
 * (`ModuleScreen` и ручные копии в модулях): замена `div` на `PageContainer`
 * не сдвигает ни пикселя.
 *
 * compact дополнительно выставляет `--page-pad-x` — горизонтальный отступ на
 * текущей ширине окна. Липкий футер формы, который вылезает на всю ширину
 * контейнера, берёт отрицательный отступ из неё (`-mx-[var(--page-pad-x)]`), а
 * не дублирует брейкпоинты.
 */
const DENSITY = {
    comfortable: 'mx-auto flex flex-col gap-6 p-4 sm:p-6 lg:p-8',
    compact: 'mx-auto flex flex-col gap-4 px-3 py-3 sm:px-4 sm:py-4 lg:px-6 lg:py-5 [--page-pad-x:0.75rem] sm:[--page-pad-x:1rem] lg:[--page-pad-x:1.5rem]',
};
/**
 * Контейнер экрана: ширина и внешние отступы страницы. Один на экран, самый
 * внешний элемент под `<main>` оболочки. Заголовок страницы он не рисует —
 * это `PageHeader` (режим `chrome: 'page'`) или навбар оболочки (`'shell'`).
 */
export const PageContainer = React.forwardRef(({ width = 'default', density = 'comfortable', className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn(DENSITY[density], WIDTH[width], className), ...props })));
PageContainer.displayName = 'PageContainer';
//# sourceMappingURL=page-container.js.map